import React from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GetfVDateFormate from "../../utils/Genaricfunctions";
import { getOrgType } from "../../utils/Token";

const ApprovedDocuments = ({ groupedDocuments, IsMultiple }) => {

    const renderTable = (documents) => (
        <TableContainer component={Paper}>
            <Table sx={{ tableLayout: "fixed", width: "100%" }}>
                <TableHead
                    sx={{
                        backgroundColor: "#F2F4F7",
                        "& .MuiTableCell-root": {
                            color: "#667085",
                            fontWeight: 600,
                        },
                    }}
                >
                    <TableRow>
                        <TableCell sx={{ width: "17%" }} hidden={getOrgType() == "Client" || !IsMultiple}>
                            Client Name
                        </TableCell>

                        <TableCell sx={{ width: "23%" }}>
                            Document Name
                        </TableCell>

                        <TableCell sx={{ width: "12%" }}>
                            Uploaded on
                        </TableCell>

                        <TableCell sx={{ width: "12%" }}>
                            Updated on
                        </TableCell>

                        <TableCell sx={{ width: "12%" }}>
                            Approved on
                        </TableCell>

                        <TableCell sx={{ width: "12%" }}>
                            Approved by
                        </TableCell>

                        <TableCell sx={{ width: "12%" }}>
                            Expires on
                        </TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {documents?.map((document) => (
                        <TableRow key={document?.documentId}>

                            <TableCell
                                sx={{
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    overflowWrap: "anywhere",
                                }}
                                hidden={getOrgType() == "Client" || !IsMultiple}
                            >
                                {document?.clientName || "-"} 
                            </TableCell>

                            <TableCell
                                sx={{
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    overflowWrap: "anywhere",
                                }}
                            >
                                {document?.documentName || "-"}
                            </TableCell>

                            <TableCell>
                                {document?.uploaded
                                    ? GetfVDateFormate(
                                        "",
                                        "",
                                        document.uploaded
                                    )
                                    : "-"}
                            </TableCell>

                            <TableCell>
                                {document?.updatedon
                                    ? GetfVDateFormate(
                                        "",
                                        "",
                                        document.updatedon
                                    )
                                    : "-"}
                            </TableCell>

                            <TableCell>
                                {document?.approvedOn
                                    ? GetfVDateFormate(
                                        "",
                                        "",
                                        document.approvedOn
                                    )
                                    : "-"}
                            </TableCell>

                            <TableCell
                                sx={{
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    overflowWrap: "anywhere",
                                }}
                            >
                                {document?.approvedBy || "-"}
                            </TableCell>

                            <TableCell>
                                {document?.expires
                                    ? GetfVDateFormate(
                                        "",
                                        "",
                                        document.expires
                                    )
                                    : "-"}
                            </TableCell>

                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );

    return (
        <>
            {Object.entries(groupedDocuments || {}).map(
                ([documentTypeName, documents], index) => (
                    <Accordion
                        key={documentTypeName}
                        defaultExpanded={index === 0}
                        sx={{
                            boxShadow: "none",
                            border: "1px solid #E4E7EC",
                            mb: 1,
                            "&:before": {
                                display: "none",
                            },
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            sx={{
                                backgroundColor: "#F2F4F7",
                            }}
                        >
                            <Typography fontWeight={600}>
                                {documentTypeName}
                            </Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                            {renderTable(documents)}
                        </AccordionDetails>
                    </Accordion>
                )
            )}
        </>
    );
};

export default ApprovedDocuments;